/* eslint-disable import/order */
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { serviceDeskServicesWithoutProjectRoute } from '@jira/router-routes__servicedesk-services-routes/src/serviceDeskServicesWithoutProjectRoute.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskServicesWithoutProjectContext, {
	LazyServicedeskServicesWithoutProjectContext,
} from './ui/services-without-project-context/index.tsx';

export const serviceDeskServicesWithoutProjectRouteEntry: Route = createEntry(
	serviceDeskServicesWithoutProjectRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'service-management.services-without-project',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskServicesWithoutProjectContext,
		resources: [...getNavigationResources(), workspaceResource, getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation, LazyServicedeskServicesWithoutProjectContext],

		meta: {
			reporting: {
				id: 'servicedesk-services-without-project',
				packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
				teamName: 'Astral',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
